import { render, staticRenderFns } from "./CaseFrom.vue?vue&type=template&id=a8274246&scoped=true&"
import script from "./CaseFrom.vue?vue&type=script&lang=js&"
export * from "./CaseFrom.vue?vue&type=script&lang=js&"
import style0 from "./CaseFrom.vue?vue&type=style&index=0&id=a8274246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8274246",
  null
  
)

export default component.exports